import { Action } from '@ngrx/store';

export enum LanguageActionTypes {
  changeLanguage = '[Language] Change',
}

export class ChangeLanguage implements Action {
  readonly type = LanguageActionTypes.changeLanguage;

  constructor(public payload: string) {}
}

export type LanguageActions = ChangeLanguage;
